import {
  getAsync,
  postAsync,
  putAsync,
  deleteAsync,
} from "../helpers/apiHelper";

const endpoint = process.env.VUE_APP_BACKEND + "/api/disciplines";

// GET discipline by id without related data
export async function getDisciplineAsync(disciplinesId) {
  return await getAsync(`${endpoint}/${disciplinesId}`);
}

// GET all disciplines in federation
export async function getDisciplinesByFederationIdAsync(federationId) {
  return await getAsync(`${endpoint}/GetAllByFederationId/${federationId}`);
}

// Get all users' disciplines
export async function getAllCurrentUserDisciplinesAsync() {
  return await getAsync(`${endpoint}/GetAllCurrentUserDisciplines`);
}

// ==== START - Managers ====

// Get all managers in discipline
export async function getDisciplineManagersAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetDisciplineManagers/${disciplineId}`);
}

// Get all disciplines available for a manager
export async function getManagerDisciplinesAsync(userId) {
  return await getAsync(`${endpoint}/GetManagerDisciplines/${userId}`);
}

// Get all managers not in discipline
export async function getManagersNotInDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetManagersNotInDiscipline/${disciplineId}`);
}

// Get if a manager is part of discipline
export async function getIsManagerPartOfDisciplineAsync(userId, disciplineId){
  return await getAsync(`${endpoint}/GetIsManagerPartOfDiscipline/${userId}/${disciplineId}`);
}

// Affect a list of managers to a discipline
export async function affectManagersToDisciplineAsync(disciplineId, usersIds) {
  return await postAsync(`${endpoint}/AffectManagersToDiscipline/${disciplineId}`, usersIds);
}

// Remove a manager from a discipline
export async function removeManagerFromDisciplineAsync(DisciplineId, userId) {
  return await deleteAsync(`${endpoint}/RemoveManagerFromDiscipline/${DisciplineId}/${userId}`);
}

// ==== END - Managers ====

// ==== START - Coaches ====

// Get all coaches in discipline
export async function getDisciplineCoachesAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetDisciplineCoaches/${disciplineId}`);
}

// Get all disciplines available for a coach
export async function getCoachDisciplinesAsync(userId) {
  return await getAsync(`${endpoint}/GetCoachDisciplines/${userId}`);
}

// Get all coaches not in discipline
export async function getCoachesNotInDisciplineAsync(disciplineId) {
  return await getAsync(`${endpoint}/GetCoachesNotInDiscipline/${disciplineId}`);
}

// Get if a coach is part of discipline
export async function getIsCoachPartOfDisciplineAsync(userId, disciplineId){
  return await getAsync(`${endpoint}/GetIsCoachPartOfDiscipline/${userId}/${disciplineId}`);
}

// Affect a list of coaches to a discipline
export async function affectCoachesToDisciplineAsync(disciplineId, usersIds) {
  return await postAsync(`${endpoint}/AffectCoachesToDiscipline/${disciplineId}`, usersIds);
}

// Remove a coach from a discipline
export async function removeCoachFromDisciplineAsync(DisciplineId, userId) {
  return await deleteAsync(`${endpoint}/RemoveCoachFromDiscipline/${DisciplineId}/${userId}`);
}

// ==== END - Coaches ====

// CREATE a discipline
export async function createDisciplineAsync(federationId, model) {
  return await postAsync(`${endpoint}/${federationId}`, model);
}

// UPDATE a discipline
export async function updateDisciplineAsync(disciplineId, model) {
  return await putAsync(`${endpoint}/${disciplineId}`, model);
}

// DELETE a discipline
export async function deleteDisciplineAsync(disciplinesId) {
  return await deleteAsync(`${endpoint}/${disciplinesId}`);
}
